import { render, staticRenderFns } from "./WithdrawMoneyBottomSheet.vue?vue&type=template&id=bebf3fe2&"
import script from "./WithdrawMoneyBottomSheet.vue?vue&type=script&lang=ts&"
export * from "./WithdrawMoneyBottomSheet.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawMoneyBottomSheet.vue?vue&type=style&index=0&id=bebf3fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports